// In your component
import React from 'react';
import { Box } from '@mui/material';
import useDisableHtmlButtons from "../../../../hooks/useDisableHtmlButtons";

const DangerouslySetHtml = ({ htmlContent, isProcessed, sx= {} }) => {
	const contentRef = useDisableHtmlButtons(htmlContent, {
		disabled: isProcessed,
		preventNavigation: true,
		styles: {
			backgroundColor: '#e0e0e0',
			color: '#666',
		},
		customHandler: (event, button) => {
			console.log('Button clicked but disabled:', button.textContent);
		}
	});
	
	return (
		<Box
			ref={contentRef}
			dangerouslySetInnerHTML={{ __html: htmlContent }}
			sx={{
				'& table': { borderCollapse: 'collapse', width: '100%' },
				'& td': { padding: '4px 8px' },
				...sx
			}}
		/>
	);
};

export default DangerouslySetHtml;